import styled from 'styled-components';

export const DriverMarker = styled.div`
  position: relative;
  transition: all 200ms;
  > svg {
    height: 31px;
    width: 25px;
  }
  > div {
    position: absolute;
    top: 0;
    display: flex;
    justify-content: center;
    padding: 6px;
    align-items: center;
    width: 25px;
    height: 25px;
    text-align: center;
  }
`;
